import React from 'react';
import { Link } from 'react-router-dom';
import { Typography, Space } from 'antd';
const { Text, Title } = Typography;

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    product: [
      { label: 'Home', href: '/' },
      { label: 'Features', href: '/#features' },
      { label: 'Pricing', href: '/#pricing' },
      { label: 'Documentation', href: '/docs' },
      { label: 'Contact', href: '/contact' },
    ],
    legal: [
      { label: 'Privacy Policy', href: '/privacy' },
      { label: 'Terms of Service', href: '/terms' },
      { label: 'Refund Policy', href: '/refund' },
      { label: 'Shipping Policy', href: '/shipping' },
      { label: 'Cookie Policy', href: '/cookies' },
    ],
  };

 

  return (
    <footer className="main-footer">
      <div className="footer-container">
        <div className="footer-grid">
          {/* Brand Section */}
          <div className="footer-brand">
            <Link to="/" className="footer-logo">
              <i className="fas fa-microchip"></i>
              <span>Elorimi</span>
            </Link>
            <Text className="footer-description">
              Launch powerful Cloud PCs and VPS servers in minutes.
            </Text>
             <Text className="footer-description">
              -<br />
              Company number: -<br />
              Registered address: -
            </Text>
          </div>

          {/* Links Sections */}
          <div className="footer-links">
            <div className="footer-column">
              <Title level={5} className="footer-title">Site Links</Title>
              <Space direction="vertical" size="small">
                {footerLinks.product.map((link, index) => (
                  <Link key={index} to={link.href} className="footer-link">
                    {link.label}
                  </Link>
                ))}
              </Space>
            </div>

            <div className="footer-column">
              <Title level={5} className="footer-title">Legal</Title>
              <Space direction="vertical" size="small">
                {footerLinks.legal.map((link, index) => (
                  <Link key={index} to={link.href} className="footer-link">
                    {link.label}
                  </Link>
                ))}
              </Space>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <Text className="footer-copyright">
            &copy; {currentYear} Elorimi. All rights reserved.
          </Text>
          <div className="footer-badges">
            <span className="footer-badge footer-badge-payment" aria-label="Visa">
              <img className="payment-logo payment-logo-visa" src="/assets/visa.svg" alt="Visa" />
            </span>
            <span className="footer-badge footer-badge-payment" aria-label="Mastercard">
              <img className="payment-logo" src="/assets/mastercard.svg" alt="Mastercard" />
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;


